export default "__VITE_ASSET__Dw6km6Tz__"